<template>
    <div class="video-monitor">
        <div class="top-wrap">
            <div class="title-wrap">
                <div class="title-h2">视频监控</div>
            </div>
        </div>
        <div class="main-wrap">
            <div style="width: 33%; height: 50%;margin-left:0.5%">
                <iframe :src="video1" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
            </div>
            <div style="width: 33%; height: 50%">
                <iframe :src="video2" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
            </div>
            <div style="width: 33%; height: 50%">
                <iframe :src="video3" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
            </div>
            <div style="width: 33%; height: 50%;margin-left:0.5%">
                <iframe :src="video4" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
            </div>
            <div style="width: 33%; height: 50%">
                <iframe :src="video5" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
            </div>
            <div style="width: 33%; height: 50%">
                <iframe :src="video6" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
export default {
    data() {
        return {
            appKey: "f7e09bed6d584d13a995b8c9f56f7954",
            appSecret: "e34739c47c80b4fdd85353a485b4361b",
            video1: "",
            video2: "",
            video3: "",
            video4: "",
            video5: "",
            video6: "",
        }
    },
    created() {

    },
    mounted() {
        // 获取token
        const videoAccessToken = this.$cookie.get("videoAccessToken");
        this.video1 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988405/1.live&autoplay=1&accessToken=${videoAccessToken}`
        this.video2 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988508/1.live&autoplay=1&accessToken=${videoAccessToken}`
        this.video3 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988532/1.live&autoplay=1&accessToken=${videoAccessToken}`
        this.video4 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988552/1.live&autoplay=1&accessToken=${videoAccessToken}`
        this.video5 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988575/1.live&autoplay=1&accessToken=${videoAccessToken}`
        this.video6 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988576/1.live&autoplay=1&accessToken=${videoAccessToken}`
        // 如果token过期  重新获取
        if (!videoAccessToken) {
            axios
                .post(
                    `https://open.ys7.com/api/lapp/token/get`,
                    qs.stringify({
                        appKey: this.appKey,
                        appSecret: this.appSecret,
                    })
                )
                .then((res) => {
                    if (res.data.code == "200") {
                        // 设置监控过期时间
                        this.$cookie.set("videoAccessToken", res.data.data.accessToken, res.data.data.expireTime);
                        this.video1 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988405/1.live&autoplay=1&accessToken=${res.data.data.accessToken}`
                        this.video2 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988508/1.live&autoplay=1&accessToken=${res.data.data.accessToken}`
                        this.video3 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988532/1.live&autoplay=1&accessToken=${res.data.data.accessToken}`
                        this.video4 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988552/1.live&autoplay=1&accessToken=${res.data.data.accessToken}`
                        this.video5 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988575/1.live&autoplay=1&accessToken=${res.data.data.accessToken}`
                        this.video6 = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/G57988576/1.live&autoplay=1&accessToken=${res.data.data.accessToken}`
                    }
                });
        }

    },
    methods: {

    }
}
</script>
<style lang="scss">
.video-monitor {
    height: 100%;
    width: 100%;
    background: url("../../../assets/image/index/bj1.jpg") no-repeat;
    background-size: 100% 100%;
    .top-wrap {
        height: px2Rem(120px);
        // height: 135px;
        // height: 7rem;
        width: 100%;
        background-image: url("../../../assets/image/index/top.png");
        background-repeat: no-repeat;
        background-position: top center;
        background-size: auto 100%;
        position: relative;
        z-index: 1;
    }
    .main-wrap {
        width: 100%;
        height: calc(100% - #{px2Rem(120px)});
        display: flex;
        flex-wrap: wrap;
    }
}
</style>